module.exports = __webpack_public_path__ + "media/images/partners/armoiries-968abbe3ea030486c9aace999ccd8caa.png";